const TERMINAL = new Set([
    'ready',
    'failed',
    'cancelled'
]);
export function isTerminal(status) {
    return TERMINAL.has(status);
}
export const RELATIONSHIP_PDF_JOB_TYPE = 'relationshipPdf';
export const BULK_SEND_PROPOSALS_JOB_TYPE = 'bulkSendProposals';
export const BULK_CREATE_DRAFTS_JOB_TYPE = 'bulkCreateDrafts';
function relationshipPdfTaskFromJob(job) {
    var _ref;
    const data = job.data;
    return {
        jobId: job.jobId,
        kind: 'relationshipPdf',
        status: job.status,
        progress: job.progress,
        updatedAt: job.updatedAt,
        seen: job.seen,
        agreementName: (_ref = data === null || data === void 0 ? void 0 : data.agreementName) !== null && _ref !== void 0 ? _ref : '',
        relationshipId: data === null || data === void 0 ? void 0 : data.relationshipId,
        downloadUrl: data === null || data === void 0 ? void 0 : data.downloadUrl,
        fileName: data === null || data === void 0 ? void 0 : data.fileName,
        error: job.error
    };
}
function bulkSendProposalsTaskFromJob(job) {
    const data = job.data;
    return {
        jobId: job.jobId,
        kind: 'bulkSendProposals',
        status: job.status,
        progress: job.progress,
        updatedAt: job.updatedAt,
        seen: job.seen,
        jobName: data.jobName,
        succeeded: data.succeeded,
        failed: data.failed,
        total: data.total
    };
}
function bulkCreateDraftsTaskFromJob(job) {
    const data = job.data;
    return {
        jobId: job.jobId,
        kind: 'bulkCreateDrafts',
        status: job.status,
        progress: job.progress,
        updatedAt: job.updatedAt,
        seen: job.seen,
        jobName: data.jobName,
        succeeded: data.succeeded,
        failed: data.failed,
        total: data.total
    };
}
export function taskFromJob(job) {
    switch(job.type){
        case RELATIONSHIP_PDF_JOB_TYPE:
            return relationshipPdfTaskFromJob(job);
        case BULK_SEND_PROPOSALS_JOB_TYPE:
            return bulkSendProposalsTaskFromJob(job);
        case BULK_CREATE_DRAFTS_JOB_TYPE:
            return bulkCreateDraftsTaskFromJob(job);
        default:
            return null;
    }
}
